import React from 'react';
import { HiCalendarDays, HiBuildingOffice } from 'react-icons/hi2';
import { IoMdMicrophone } from 'react-icons/io';

/**
 * Left drawer for switching between calendar, events, and rooms occupancy views.
 */
export default function SchedulePrimaryViewDrawer({
    isOpen,
    isAnimating,
    onClose,
    timeMode,
    onSelectPrimaryView,
    onChangeInstitution,
}) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50">
            <div
                className={`absolute inset-0 bg-black transition-opacity duration-300 ${isAnimating ? 'bg-opacity-30 opacity-100' : 'bg-opacity-0 opacity-0'}`}
                onClick={onClose}
                role="presentation"
            />
            <div className={`absolute top-0 left-0 h-full w-64 bg-white shadow-xl transform transition-transform duration-300 ease-out flex flex-col ${isAnimating ? 'translate-x-0' : '-translate-x-full'}`}>
                <div className="p-4 border-b flex items-center justify-between shrink-0">
                    <span className="text-lg font-semibold text-gray-800">Views</span>
                    <button
                        type="button"
                        className="p-1 rounded-md text-gray-600 hover:text-blue-600"
                        onClick={onClose}
                        aria-label="Close menu"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                    </button>
                </div>
                <div className="p-2 space-y-1 flex-1 min-h-0">
                    <button
                        type="button"
                        className={`w-full text-left px-3 py-2 rounded-md flex items-center gap-2 ${timeMode !== 'occupancy' && timeMode !== 'events' ? 'bg-gray-200 text-gray-900' : 'hover:bg-gray-100 text-gray-700'}`}
                        onClick={() => onSelectPrimaryView('calendar')}
                    >
                        <HiCalendarDays className="h-5 w-5" />
                        <span>Calendar</span>
                    </button>
                    <button
                        type="button"
                        className={`w-full text-left px-3 py-2 rounded-md flex items-center gap-2 ${timeMode === 'events' ? 'bg-gray-200 text-gray-900' : 'hover:bg-gray-100 text-gray-700'}`}
                        onClick={() => onSelectPrimaryView('events')}
                    >
                        <IoMdMicrophone className="h-5 w-5" />
                        <span>Events</span>
                    </button>
                    <button
                        type="button"
                        className={`w-full text-left px-3 py-2 rounded-md flex items-center gap-2 ${timeMode === 'occupancy' ? 'bg-gray-200 text-gray-900' : 'hover:bg-gray-100 text-gray-700'}`}
                        onClick={() => onSelectPrimaryView('occupancy')}
                    >
                        <HiBuildingOffice className="h-5 w-5" />
                        <span>Rooms Occupancy</span>
                    </button>
                </div>
                {onChangeInstitution && (
                    <div className="mt-auto shrink-0 p-4 border-t border-gray-100">
                        <button
                            type="button"
                            className="w-full text-left px-3 py-2 rounded-md text-sm text-gray-700 border border-gray-200 hover:bg-gray-50"
                            onClick={onChangeInstitution}
                        >
                            Change institution
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}
